export interface Auth0OAuthOpts {
    domain: string,
    clientID: string,
	scope?: string,
    redirectUri: string,
    audience?: string,
    responseType: string,
    returnTo?: string,
    urlOpener?: (url:string, redirectUrl: string) => Promise<any>
}